<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div>
        <span style="font-size: 13px; color:#97a8be">首页 / 财务管理 / 充值管理(C)</span>
      </div>
    </div>
    <div style="overflow:hidden; padding:15px 15px; padding-top: 0; line-height: 43px ">
      <span class="leftTd">用户ID</span>
      <input class="boxText" v-model="userId" style="width: 200px; margin-left: 10px; margin-right: 10px;">
      <span class="leftTd">上级ID</span>
      <input class="boxText" v-model="leader" style="width: 200px; margin-left: 10px; margin-right: 10px;">
      <span class="leftTd">时间段</span>
      <datepicker style="margin-left: 10px;" v-model="startTime"></datepicker> -
      <datepicker style="margin-right: 10px;" v-model="endTime"></datepicker>
      <span class="leftTd">状态</span>
      <select class="boxText" v-model="state" style="width: 100px; margin-left: 10px; margin-right: 10px;">
        <option value="">全部</option>
        <option value="待审核">待审核</option>
        <option value="充值成功">充值成功</option>
        <option value="充值失败">充值失败</option>
      </select>
      <input @click="selectAdminList" type="button" style="cursor: pointer; padding: 7px 25px; border-radius: 3px; margin-left: 10px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="搜索" />
    </div>
    <!--    <div style="overflow:hidden; padding:0 15px;">-->
    <!--      <div @click="addAdmin" class="addBtn">+ 添加文章</div>-->
    <!--    </div>-->
    <div style="padding: 10px 15px">
      <div>
        <table width="100%">
          <tr>
            <th class="th">
              操作
            </th>
            <th class="th">
              充值单号
            </th>
            <th class="th">
              充值金额
            </th>
            <th class="th">
              充值类型
            </th>
            <th class="th">用户ID</th>
            <th class="th">用户昵称</th>
            <th class="th">手机号码</th>
            <th class="th">收款卡信息</th>
            <th class="th">充值凭证</th>
            <th class="th">充值状态</th>
            <th class="th">备注</th>
            <th class="th">到账时间</th>
            <th class="th">充值时间</th>
          </tr>
          <tr :key="index" v-for="(value,index) in adminList">
            <td class="td" style="width: 80px">
              <div style="overflow: hidden">
<!--                <div @click="sendCard(value.topId)" :style="{display:(value.topState=='待发卡')?'':'none'}" style="cursor: pointer; float: left; color: #33cc57">-->
<!--                  发卡-->
<!--                </div>-->
                <div @click="auditWithDraw(value.topId,0,value.topUserId)" :style="{display:(value.topState=='待审核')?'':'none'}" style="cursor: pointer; float: left; color: #33cc57">
                  通过
                </div>
                <div @click="auditWithDraw(value.topId,1,value.topUserId)" :style="{display:(value.topState=='待审核')?'':'none'}" style="cursor: pointer; margin-left: 10px; float: left; color: #ff0000">
                  驳回
                </div>
              </div>
            </td>
            <td class="td" :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" style="min-width: 50px;">
              {{ value.topNum }}
            </td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">
              {{ value.topPrice }}
            </td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">
              {{ value.topType }}
            </td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">{{ value.topUserId }}</td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">{{ value.topUserName.split('-')[0] }}</td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">{{ value.topUserPhone }}</td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">{{ value.topBankNote }}</td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">
              <template v-if="value.topPhoto!=''">
                <a :href="imgUrl+value.topPhoto" target="_blank" style="color: #1890ff">查看</a>
              </template>
            </td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">{{ value.topState }}</td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">{{ value.topNote }}</td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">{{ value.topToTime }}</td>
            <td :style="{color:value.topUserName.indexOf('-1')!=-1?'red':'#606266'}" class="td">{{ value.topTime }}</td>
          </tr>
        </table>
      </div>
      <div style="padding-top: 20px; font-size: 12px; color: #606266; text-align: right">
        一页显示 <input v-model="num" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/>
        条，共<span v-html="count"></span>条数据
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shouye.png" v-on:click="currPage(1)" title="首页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shangyiye.png" v-on:click="currPage(2)" title="上一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <input v-model="page" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/> / <span
          v-html="countPage"></span>页
        <img src="@/assets/home/xiayiye.png" v-on:click="currPage(3)" title="下一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/weiye.png" v-on:click="currPage(5)" title="尾页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
      </div>
    </div>
    <div :style="{display:showPrompt==1?'':'none'}" style="position: fixed; _position: absolute; top: 0; left: 0; bottom: 0; right: 0; margin: auto; width: 350px; height: 200px;
background-color: white; box-shadow: 0 0 3px #e8e8e8; z-index: 999">
      <div style="text-align: center; color: black; font-weight: bold; padding: 15px;">
        驳回提现
      </div>
      <div style="padding: 15px; text-align: center">
        <div>
          <input class="boxText" v-model="userInput" placeholder="请输入审核备注" style="width: 90%" />
        </div>
        <div style="padding-top: 25px;">
          <input @click="auditWithDrawByNo" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="确认驳回" />
          <input @click="chanelAudit" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
        </div>
      </div>
    </div>
    <div :style="{display:showBankBox==1?'':'none'}" style="position: fixed; _position: absolute; top: 0; left: 0; bottom: 0; right: 0; margin: auto; width: 550px; height: 390px;
background-color: white; box-shadow: 0 0 5px #aca9a9; z-index: 999">
      <div style="text-align: center; color: black; font-weight: bold; padding: 15px;">
        发送银行卡
      </div>
      <span @click="closeBankBox" style="cursor: pointer; position: absolute; top: 15px; right: 15px; z-index: 999">关闭</span>
      <div style="padding: 15px; text-align: left">
        <div style="height: 310px; overflow-y: scroll">
          <div>
            <table width="100%">
              <tr>
                <th class="th">
                  操作
                </th>
                <th class="th">
                  银行名称
                </th>
                <th class="th">
                  支行
                </th>
                <th class="th">
                  开户人
                </th>
                <th class="th">卡号</th>
              </tr>
              <tr :key="index" v-for="(value,index) in bankList">
                <td class="td">
                  <div @click="sendBank(value.bankId)" style="cursor: pointer;color: #33cc57">
                    发送
                  </div>
                </td>
                <td class="td" style="min-width: 50px;">
                  {{ value.bankName }}
                </td>
                <td class="td">
                  {{ value.bankChildName }}
                </td>
                <td class="td">
                  {{ value.bankUserName }}
                </td>
                <td class="td">{{ value.bankCard }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {closeLoading, convertDateToISO, DO_NET_URL, FILE_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost} from "@/main";
import Datepicker from 'vue2-datepicker';

export default {
  name: "TopUpList",
  components: {
    Datepicker
  },
  data(){
    return{
      showBankBox:0,
      showPrompt:0,
      userInput: '',
      userId:"",
      phone:"",
      leader:"",
      state:"",
      startTime:"",
      endTime:"",
      adminList:[],
      page:1,
      num:10,
      count:0,
      countPage:0,
      imgUrl:"",
      curId:0,
      bankList:[],
      topUser:"",
    }
  },
  mounted(){
    if(localStorage.getItem("topAccount")!=null&&localStorage.getItem("topAccount")!=""){
      this.topUser=localStorage.getItem("topAccount")
    }
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    this.selectAdminList()
    axiosGet(DO_NET_URL+"api/GetBankByTopUp",function (res){
      that.bankList=res.data
    })
  },
  methods: {
    sendBank(id){
      let that=this
      if(confirm("确认发送此银行卡？")){
        axiosPost(DO_NET_URL+"topUp/SendBank?topUpId="+this.curId+"&bankId="+id,"",function (res){
          if(res.code==200){
            toask("发送成功！",6)
            that.showBankBox=0;
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    sendCard(id){
      this.curId=id
      this.showBankBox=1
    },
    closeBankBox(){
      this.showBankBox=0;
    },
    chanelAudit(){
      this.showPrompt=0
    },
    copyBankMsg(id,state,address,price){
      let that=this
      let msg="链：TRC20\n钱包地址：" + address + "\n到账金额："+price
      //执行复制
      const input = document.createElement('textarea');
      input.value = msg; // 设置要复制的文本
      document.body.appendChild(input); // 添加input元素到DOM
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行复制操作
      document.body.removeChild(input); // 移除input元素
      toask('已复制到剪切板',6); // 可选：弹窗提示复制成功
      if(state=="待审核"){
        axiosPost(DO_NET_URL+"withDraw/CopyBankMsgByWithDrawUsdt?id="+id,"",function (res){
          that.selectAdminList()
        })
      }
    },
    updateAdmin(obj){
      localStorage.setItem("UPDATEOBJ",obj)
      this.$emit("send",'issueListByInvestId')
    },
    auditWithDrawByNo(){
      if(this.userInput==""){
        toask("请输入驳回原因！",6)
        return
      }
      if(confirm("确认审核此申请吗？")){
        let that=this
        loading("加载中")
        axiosPost(DO_NET_URL+"withDraw/AuditWithDrawUsdt?id="+this.curId+"&type=1&note="+this.userInput,"",function (res){
          console.log(res.data)
          closeLoading()
          if(res.code==200){
            that.showPrompt=0
            toask("审核成功！",6)
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    auditWithDraw(id, type,userCode) {
      if (type == 0) {
        let that = this
        loading("请求中")
        axiosGet(DO_NET_URL + "topUp/GetTopUp?userId=" + userCode+ "&state=&startTime=&endTime=&leader=&page=1&num=200", function (res){
          closeLoading()
          console.log(res.data.list)
          let list=res.data.list
          let msg=""
          if(list.length>0){
            for(let i=0;i<list.length;i++){
              if(list[i].topId<id){
                msg="该用户上次充值时间【"+list[i].topTime+"】;充值金额【￥"+list[i].topPrice+"】;状态【"+list[i].topState+"】，确认通过此充值申请吗？"
                break
              }
            }
            if(msg==""){
              msg="该用户第一次发起充值，确认通过此充值申请吗？"
            }
          }else{
            msg="该用户第一次发起充值，确认通过此充值申请吗？"
          }
          if (confirm(msg)) {
            loading("加载中")
            axiosPost(DO_NET_URL + "topUp/AuditTopUp?id=" + id + "&type=" + type, "", function (res) {
              console.log(res.data)
              closeLoading()
              if (res.code == 200) {
                toask("审核成功！", 6)
                that.selectAdminList()
              } else {
                toask(res.data, 6)
              }
            })
          }
        })


      } else {
        if (confirm("确认审核此申请吗？")) {
          let that = this
          loading("加载中")
          axiosPost(DO_NET_URL + "topUp/AuditTopUp?id=" + id + "&type=" + type, "", function (res) {
            console.log(res.data)
            closeLoading()
            if (res.code == 200) {
              toask("审核成功！", 6)
              that.selectAdminList()
            } else {
              toask(res.data, 6)
            }
          })
        }
      }


    },
    deleteAdmin(id){
      if(confirm("确认删除此申请吗？")){
        let that=this
        loading("加载中")
        axiosPost(DO_NET_URL+"filePhoto/DeleteFilePhoto?id="+id,"",function (res){
          console.log(res.data)
          closeLoading()
          if(res.code==200){
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    addAdmin(){
      this.$emit("send",'addNews')
    },
    currPage(num){
      if(num==1){
        this.page=1
      }else if(num==5){
        this.page=this.countPage
      }else if(num==2){
        if(this.page>1){
          this.page-=1
        }
      }else{
        if(this.page<this.countPage){
          this.page+=1
        }
      }
      this.selectAdminList()
    },
    async selectAdminList(){
      let that=this
      loading("加载中")
      console.log(this.startTime)
      let t1=""
      let t2=""
      if(this.startTime!=""){
        t1=convertDateToISO(this.startTime)
      }
      if(this.endTime!=""){
        t2=convertDateToISO(this.endTime)
      }
      console.log(this.startTime)
      console.log(t1)
      axiosGet(DO_NET_URL+"topUp/GetTopUp?topUser="+this.topUser+"&userId="+this.userId+"&state="+this.state+"&startTime="+t1+"&endTime="+t2+"&leader="+this.leader+"&page="+this.page+"&num="+this.num,function (res){
        console.log(res.data)
        closeLoading()
        that.imgUrl=FILE_URL
        that.adminList=res.data.list
        that.count=res.data.num
        let page=parseInt(res.data.num/that.num)
        if(res.data.num%that.num>0){
          page+=1
        }
        that.countPage=page
        // localStorage.setItem("imgUrl",res.data.imgUrl)
      })
    },
  }
}
</script>

<style scoped>
@import 'vue2-datepicker/index.css';
.prompt-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
.prompt-box input {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
}
.prompt-box button {
  padding: 10px 15px;
  margin-right: 10px;
  border: none;
  outline: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}
.prompt-box button:hover {
  background-color: #0056b3;
}
.text1{
  border: 1px solid #dcdfe6;
  font-size: 12px;
  border-radius: 2px;
  outline: none;
  padding: 3px 10px;
}
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 35px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700;}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0px 10px; width: auto; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>